import { VatCategoryT, VatFieldValue } from './types';

/**
 * Creates {@link VatFieldValue} from backend values.
 *
 * @param vatCategories - list of categories fetched separately; undefined if not initialized yet.
 * @param vatCategoryCode - VAT category code received from backend; may be undefined if item was created pre-VAT categories era.
 * @param vatPercentage - VAT percentage received from backend; can be omitted, VAT category code should be provided in this case.
 * @returns Properly constructed {@link VatFieldValue}.
 */
export const initialVatFieldValue = (
  vatCategories: VatCategoryT[] | undefined,
  vatCategoryCode: string | undefined,
  vatPercentage?: number,
): VatFieldValue => {
  if (!vatCategories) {
    return {
      type: vatCategoryCode ? 'categories' : 'manual',
      categoryCode: vatCategoryCode,
      percentage: vatPercentage,
    };
  }
  const category = vatCategories.find(vc => vc.code === vatCategoryCode);
  return category && (vatPercentage === category.vat_percentage || vatPercentage === undefined)
    ? {
        type: 'categories',
        categoryCode: category.code,
        percentage: category.vat_percentage,
      }
    : {
        type: 'manual',
        categoryCode: undefined,
        percentage: vatPercentage,
      };
};
